<div class="fixing-audit-view">
  <div class="measure-text ag-cell-value ag-bcdfx" #measureDiv></div>
  <div class="audit-body">
    <ag-grid-angular
      class="ag-bcdfx"
      style="width: 100%; height: 100%"
      enableColResize
      enableSorting
      rowSelection="none"
      (contextmenu)="handleClick($event)"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [frameworkComponents]="frameworkComponents"
      [showToolPanel]="false"
    >
      [toolPanelSuppressSideButtons]="true" multiSortKey="ctrl"
    </ag-grid-angular>
    <bfx-blotter-column-selector
      [currentLadderBlotter]="blotterInstance"
      bfxElementOnBody
    ></bfx-blotter-column-selector>
  </div>
</div>
